import { render, staticRenderFns } from "./ServicejobIndex.vue?vue&type=template&id=ec850f5a"
import script from "./ServicejobIndex.vue?vue&type=script&lang=js"
export * from "./ServicejobIndex.vue?vue&type=script&lang=js"
import style0 from "./ServicejobIndex.vue?vue&type=style&index=0&id=ec850f5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports